import { Cascader } from 'antd';
import { AntCascader } from './styles/cascader.style';

const StyledCascader = AntCascader(Cascader);

export default StyledCascader;
